import { render, staticRenderFns } from "./Demfor.vue?vue&type=template&id=16207375&"
import script from "./Demfor.vue?vue&type=script&lang=js&"
export * from "./Demfor.vue?vue&type=script&lang=js&"
import style0 from "./Demfor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports